import Alert from 'antd/lib/alert'

import 'antd/lib/alert/style'

export * from 'antd/lib/alert'

export default Alert
